import { TQuestion } from '../api/type'
import React, { createContext, useContext, useState } from 'react'

// export interface Question {
//   id: string
//   bulk_session_id: string
//   subject: string
//   topic: string
//   question: string
//   answer: string
//   solution: string
// }

interface QuestionContextProps {
  question: TQuestion | null
  setQuestion: (question: TQuestion) => void
  clearQuestion: () => void
}

const QuestionContext = createContext<QuestionContextProps | undefined>(
  undefined
)

export const useQuestion = () => {
  const context = useContext(QuestionContext)
  if (!context) {
    throw new Error('useQuestion must be used within a QuestionProvider')
  }
  return context
}

type IPropsType = {
  children: React.ReactNode
}

export const QuestionProvider = ({ children }: IPropsType) => {
  const [question, setQuestion] = useState<TQuestion | null>(null)

  const clearQuestion = () => setQuestion(null)

  return (
    <QuestionContext.Provider value={{ question, setQuestion, clearQuestion }}>
      {children}
    </QuestionContext.Provider>
  )
}
